<template>
  <base-tool-tip
    :icon-path="heartIcon"
  >
    <div class="ri-label">
      {{ toolTipText }}
      <br>
      <span
        class="update-goal-tooltip-btn-text margin-top-xs"
        @click="updatePersonalGoal"
      >לעריכת היעד האתגר</span>
    </div>
  </base-tool-tip>
</template>

<script lang="ts" setup>

import heartIcon from '../../assets/heart.svg';
import useUpdatePersonalGoalModal from '../../composables/useUpdatePersonalGoalModal';
import { ACTION } from '../UpdatePersonalGoalModal/consts';
import BaseToolTip from '../Common/BaseToolTip.vue';

const toolTipText = 'יש התלבטויות לגבי יעד האתגר? אפשר לערוך אותו';
const { openUpdatePersonalGoalModal } = useUpdatePersonalGoalModal();

function updatePersonalGoal() {
  openUpdatePersonalGoalModal(ACTION.UPDATE);
}

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';

.update-goal-tooltip-btn-text {
  font-weight: bold;
  color: $riseup_blue;
  cursor: pointer;
}
</style>
